import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=61d3b136&scoped=true"
import script from "./activity-detail.vue?vue&type=script&lang=js"
export * from "./activity-detail.vue?vue&type=script&lang=js"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=61d3b136&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3b136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d3b136')) {
      api.createRecord('61d3b136', component.options)
    } else {
      api.reload('61d3b136', component.options)
    }
    module.hot.accept("./activity-detail.vue?vue&type=template&id=61d3b136&scoped=true", function () {
      api.rerender('61d3b136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/activity-detail.vue"
export default component.exports